














































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import CountryBillPO from "@/store/entities/finance/countrybillpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/lib/util";

class countrybillpodetail {
  name: string;
  dailyuse: number; //用量
  dailyprice: number; //价格
  dailyammount: number; //金额
  dailybeginuse: number; //期初数
  dailyenduse: number; //期末数
}

@Component({
  components: { TreeSelect },
})
export default class EditCountryBill extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "1" }) iteminfo: string;
  countrybillpo: CountryBillPO = new CountryBillPO();
  isAble: boolean = true;
  columns: any[] = [];
  columnsdata: any[] = [];
  countrybillpodetail = new countrybillpodetail();
  loading: boolean = false;
  //创建页面时
  async created() {
    await this.areaTree();
    await this.getOrganizations();
  }
  //改变时间
  changeDate(val) {
    this.countrybillpo.timeMonth = val;
  }
  //创建时
  create() { }
  //保存
  save() {
    (this.$refs.priceForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        console.log(this.countrybillpo);
        await this.$store
          .dispatch({
            type: "countrybills/update",
            data: this.countrybillpo,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.loading = false;
        (this.$refs.priceForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.priceForm as any).resetFields();
    this.$emit("input", false);
  }
  //区域
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //页面显示
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.countrybillpo = Util.extend(
        true,
        {},
        this.$store.state.countrybills.countryBillsItems
      );
    }
  }
  //规则
  ruleValidate = {
    timeMonth: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    powerNumber: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    totalUse: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    totalAmmount: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    basePrice: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    baseAmmount: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    baseUse: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    valleyUse: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    valleyPrice: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    valleyAmmount: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    peakUse: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    peakPrice: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    peakAmmount: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    flatUse: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    flatPrice: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    flatAmmount: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    subTotal: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    forceRatio: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    forceRatioAmmount: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    descrption: [
      {
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [], //区域
      organizations: [], //组织
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //enter事件
  handnext(event) {
    switch (event) {
      case "baseAmmount":
        this.countrybillpo.baseAmmount = Number.parseFloat(
          (this.countrybillpo.baseUse * this.countrybillpo.basePrice).toFixed(2)
        );
        this.calculationTotal();
        break;
      case "tipAmmount":
        this.countrybillpo.tipAmmount =
          this.countrybillpo.tipPrice * this.countrybillpo.tipUse;
        this.calculationTotal();
        break;
      case "peakAmmount":
        this.countrybillpo.peakAmmount = Number.parseFloat(
          (this.countrybillpo.peakPrice * this.countrybillpo.peakUse).toFixed(2)
        );
        this.calculationTotal();
        break;
      case "flatAmmount":
        this.countrybillpo.flatAmmount = Number.parseFloat(
          (this.countrybillpo.flatPrice * this.countrybillpo.flatUse).toFixed(2)
        );
        this.calculationTotal();
        break;
      case "valleyAmmount":
        this.countrybillpo.valleyAmmount = Number.parseFloat(
          (
            this.countrybillpo.valleyPrice * this.countrybillpo.valleyUse
          ).toFixed(2)
        );
        this.calculationTotal();
        break;
      case "totalAmmount":
        this.countrybillpo.totalAmmount =
          this.countrybillpo.subTotal - this.countrybillpo.forceRatioAmmount;
        break;
      default:
        break;
    }

    this.showinfo();
    (this.$refs[event] as HTMLElement).focus();
  }
  //计算总量
  calculationTotal() {
    this.countrybillpo.subTotal =
      this.countrybillpo.baseAmmount +
      this.countrybillpo.tipAmmount +
      this.countrybillpo.peakAmmount +
      this.countrybillpo.flatAmmount +
      this.countrybillpo.valleyAmmount;
    this.countrybillpo.totalUse =
      this.countrybillpo.tipUse +
      this.countrybillpo.peakUse +
      this.countrybillpo.flatUse +
      this.countrybillpo.valleyUse;
  }
  //重新赋值
  showinfo() {
    (this.countrybillpo as any) = {
      id: this.countrybillpo.id,
      organizationId: this.countrybillpo.organizationId,
      areaId: this.countrybillpo.areaId,
      timeMonth: this.countrybillpo.timeMonth,
      powerNumber: this.countrybillpo.powerNumber,
      baseAmmount: this.countrybillpo.baseAmmount,
      baseUse: this.countrybillpo.baseUse,
      basePrice: this.countrybillpo.basePrice,
      totalUse: this.countrybillpo.totalUse,
      totalAmmount: this.countrybillpo.totalAmmount,
      subTotal: this.countrybillpo.subTotal,
      forceRatio: this.countrybillpo.forceRatio,
      forceRatioAmmount: this.countrybillpo.forceRatioAmmount,
      tipBeginUse: this.countrybillpo.tipBeginUse,
      tipEndUse: this.countrybillpo.tipEndUse,
      tipUse: this.countrybillpo.tipUse,
      tipPrice: this.countrybillpo.tipPrice,
      tipAmmount: this.countrybillpo.tipAmmount,
      peakBeingUse: this.countrybillpo.peakBeginUse,
      peakEndUse: this.countrybillpo.peakEndUse,
      peakUse: this.countrybillpo.peakUse,
      peakPrice: this.countrybillpo.peakPrice,
      peakAmmount: this.countrybillpo.peakAmmount,
      flatBeingUse: this.countrybillpo.flatBeginUse,
      flatEndUse: this.countrybillpo.flatEndUse,
      flatPrice: this.countrybillpo.flatPrice,
      flatUse: this.countrybillpo.flatUse,
      flatAmmount: this.countrybillpo.flatAmmount,
      valleyBeginUse: this.countrybillpo.valleyBeginUse,
      valleyEndUse: this.countrybillpo.valleyEndUse,
      valleyPrice: this.countrybillpo.valleyPrice,
      valleyUse: this.countrybillpo.valleyUse,
      valleyAmmount: this.countrybillpo.valleyAmmount,
      lossUse: this.countrybillpo.lossUse,
      lossAmmount: this.countrybillpo.lossAmmount,
      description: this.countrybillpo.description,
    };
  }
}
